import { render, staticRenderFns } from "./LaboratoryPromocodes.vue?vue&type=template&id=2ce858d3&scoped=true"
import script from "./LaboratoryPromocodes.vue?vue&type=script&lang=js"
export * from "./LaboratoryPromocodes.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryPromocodes.vue?vue&type=style&index=0&id=2ce858d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce858d3",
  null
  
)

export default component.exports